import Dashboard from '@/pages/dashboard'

export default {
  path: '/dashboard',
  name: 'Dashboard',
  component: Dashboard
}



// WEBPACK FOOTER //
// ./src/router/dashboard.js